import React, { useState, useEffect } from "react";
import ProductDetail from "../productdetail/ProductDetail";
import { getApiData, getApiErrors } from "../../../frontend/api/http";

export interface ProductQuickAddToCartProps {
    productSlug: string;
    productName?: string;
}

const ProductQuickAddToCart: React.FC<ProductQuickAddToCartProps> = ({
    productSlug,
}) => {
    const [loading, setLoading] = useState(true);
    const [productData, setProductData] = useState<any>(null);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        const loadProductData = async () => {
            try {
                setLoading(true);

                // Call API to get product detail (same endpoint as quick view)
                const response = await fetch(`/product/detailajax?slug=${productSlug}`);
                const result = await response.json();
                const payload = getApiData<any>(result);

                if (!payload?.product) {
                    throw new Error(
                        getApiErrors(result)[0] || "Không thể tải thông tin sản phẩm"
                    );
                }

                setProductData(payload);
            } catch (err) {
                console.error("Error loading product data:", err);
                setError(
                    err instanceof Error
                        ? err.message
                        : "Không thể tải thông tin sản phẩm"
                );
            } finally {
                setLoading(false);
            }
        };

        if (productSlug) {
            loadProductData();
        }
    }, [productSlug]);

    if (loading) {
        return (
            <div className="flex items-center justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-3 text-gray-600">
                    Đang tải thông tin sản phẩm...
                </span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-8">
                <div className="text-red-500 mb-4">
                    <svg
                        className="w-12 h-12 mx-auto mb-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
                <h3 className="text-base font-medium text-gray-900 mb-2">
                    Có lỗi xảy ra
                </h3>
                <p className="text-gray-600 text-sm">{error}</p>
            </div>
        );
    }

    if (!productData || !productData.product) {
        return (
            <div className="text-center py-8">
                <h3 className="text-base font-medium text-gray-900 mb-2">
                    Không tìm thấy sản phẩm
                </h3>
                <p className="text-gray-600 text-sm">
                    Sản phẩm {productSlug} không tồn tại
                </p>
            </div>
        );
    }

    const {
        product,
        productProps: product_props,
        productSettings: product_settings,
        websitePricePolicyId: website_price_policy_id,
        activePricePolicyId: active_price_policy_id,
    } = productData;

    return (
        <div className="product-quick-add-to-cart">
            {/* Product Name - compact */}
            <div className="mb-3">
                <h3 className="text-base font-semibold text-gray-900 line-clamp-2">
                    {product.name}
                </h3>
            </div>

            {/* Reuse ProductDetail with isQuickAddToCart flag - 
          This renders variant picker, quantity selector, and action buttons */}
            <ProductDetail
                productProps={product_props}
                productSettings={product_settings}
                websitePricePolicyId={website_price_policy_id}
                selectedPricePolicyId={active_price_policy_id}
                isQuickView={true}
                isQuickAddToCart={true}
            />
        </div>
    );
};

export default ProductQuickAddToCart;
